import {connect} from "react-redux";
import VerifyUCDDetails from "./Verify";
import {bindActionCreators} from "redux";
import {verifyUCD, otpGenerate, firmType} from "../../../../service/Dealer/action";
import {getLeadById} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    verifiedUCD:state.Dealer.verifiedUCD,
    otp:state.Dealer.otp,
    firmTypesValue:state.Dealer.firm,
    leadById:state.Lead.leadById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            verifyUCD,
            otpGenerate,
            firmType,
            getLeadById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(VerifyUCDDetails);
